import React from 'react';
import { TransacCompleteModal } from './styles';
import { Button } from 'antd';
import { withTranslation } from 'react-i18next';
import { TRANSACTION_COMPLETE_MODAL } from './translationValues';
const NAMESPACES = ['TRANSACTION_COMPLETE_MODAL'];

const TransactionCompleteModal = ({ visible, onClose, t }) => {
  return (
    <TransacCompleteModal
      visible={visible}
      title={t(TRANSACTION_COMPLETE_MODAL.TRANSACTION_COMPLETE_TITLE.key, TRANSACTION_COMPLETE_MODAL.TRANSACTION_COMPLETE_TITLE.value)}
      footer={[<Button onClick={() => onClose(false)}>{t(TRANSACTION_COMPLETE_MODAL.TRANSACTION_MODAL_OK_BUTTON.key, TRANSACTION_COMPLETE_MODAL.TRANSACTION_MODAL_OK_BUTTON.value)}</Button>]}
      centered
      closable={false}
      width={700}
    >
      <svg
        width="70px"
        height="80px"
        viewBox="0 0 60 60"
        xmlns="http://www.w3.org/2000/svg"
        >
        <circle cx="30" cy="30" r="28" stroke="#4CAF50" stroke-width="4" fill="none" />
        <path
            d="M18 30l8 8 16-16"
            stroke="#4CAF50"
            stroke-width="4"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        </svg>

      <h4>
        {t(TRANSACTION_COMPLETE_MODAL.TRANSACTION_MESSAGE.key, TRANSACTION_COMPLETE_MODAL.TRANSACTION_MESSAGE.value)}
      </h4>
    </TransacCompleteModal>
  );
};

export default withTranslation(NAMESPACES)(TransactionCompleteModal);
